import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  forwardRef,
  OnDestroy,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { debounce } from 'lodash-es';
import { MessageService } from 'primeng/api';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'vb-input-number',
  templateUrl: './vb-input-number.component.html',
  styleUrls: ['./vb-input-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VbInputNumberComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class VbInputNumberComponent implements OnInit, OnChanges, OnDestroy {
  private readonly renderer = inject(Renderer2);
  private readonly elementRef = inject(ElementRef);
  private readonly store = inject(Store);
  private readonly ms = inject(MessageService);
  public utilService = inject(UtilService);

  @Input() element: any;
  @Input() disableField = false;
  @Input() formData: any = null;
  numVal: any;
  maxVal: any = null;
  minVal: any = 0;
  private isFocused = false;
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;

  ngOnInit(): void {
    if (this.element.name === 'f_minVal' || this.element.name === 'f_maxVal') {
      this.minVal = null;
    } else if (this.element.name === 'detailViewWidth') {
      this.minVal = 10;
      this.maxVal = 80;
    } else {
      this.minVal = 0;
    }
    this.setDisableField();
  }

  setDisableField() {
    if (
      (this.formData?.f_sysF &&
        ((this.element?.name === 'f_maxL' && this.formData?.name !== 'Pid' && this.formData?.name !== 'Sid') ||
          this.element?.name !== 'f_maxL')) ||
      (this.formData.purpose && this.formData.purpose === 'REFERENCE')
    ) {
      this.disableField = true;
    }
  }

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.modelValue = value;
    this.numVal = value;
    if (!value && this.element.name === 'detailViewWidth') {
      this.numVal = 40;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(val) {
    if (this.element?.name === 'pageLimit') {
      const isValid = this.validatePageLimits(!this.isFocused);
      if (!isValid && this.isFocused) {
        return;
      }
      val = this.numVal;
    }
    this.modelValue = val;
    this.onChange(this.modelValue);
  }

  validatePageLimits(applyDefaultValue = true) {
    const val = Number(this.numVal);
    const isValid = Number.isInteger(val) && val > 0 && val <= 1000 && !Number.isNaN(val);
    if (isValid) {
      this.numVal = val;
    } else if (applyDefaultValue) {
      this.numVal = this.element?.defaultValue;
    }
    return isValid;
  }

  onFocus() {
    this.isFocused = true;
  }

  onBlur() {
    this.isFocused = false;
    if (this.element?.name === 'pageLimit') {
      const previousValue = this.modelValue;
      this.validatePageLimits(true);
      if (previousValue !== this.numVal) {
        this.modelValue = this.numVal;
        this.onChange(this.modelValue);
      }
    }
    this.utilService.flushDebounce(this.debounceValChanges);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  debounceValChanges = debounce(this.set.bind(this), 1000);

  valueChange(event) {
    if (
      (this.element?.key === 'f_minVal' && this.formData?.f_minVal === event.value) ||
      (this.element?.key === 'f_maxVal' && this.formData?.f_maxVal === event.value)
    ) {
      return;
    }
    this.debounceValChanges(event.value);
  }

  ngOnChanges(): void {
    this.setDisableField();
  }

  ngOnDestroy(): void {
    //AutoUnsubscribe
    $(this.elementRef.nativeElement).remove();
  }
}
